<template>
  <FriedModal class="intersection-modal" :closable="false">
    <div class="intersection">
      <img
        class="template-gif"
        src="../assets/ProposalManagementHeader.gif"
        alt="Loading template gif"
      />
      <FriedProgressBar aria-labelledby="preparing-title" class="progress-bar" :value="progress" />
      <div>
        <FriedH4 class="title">
          {{ t('preparing-your-template') }}
        </FriedH4>
      </div>
    </div>
  </FriedModal>
</template>
<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { ProgressConstants } from '../constants/progress.constants';
import { useTemplateGalleryStore } from '../store/template-gallery.store';

const props = withDefaults(
  defineProps<{
    templateId?: string;
  }>(),
  {
    templateId: '',
  }
);

const emit = defineEmits<{
  close: [];
}>();

const templateGalleryStore = useTemplateGalleryStore();
const progress = ref(0);
const hasNewTemplate = computed(() => templateGalleryStore.newTemplateId !== '');
const router = useRouter();
const { t } = useI18n();

const startProgress = () => {
  setTimeout(() => {
    if (progress.value === 90) {
      return;
    }
    progress.value++;
    startProgress();
  }, 100);
};

onMounted(() => {
  templateGalleryStore.copy(props.templateId);
  startProgress();
});

watch(
  () => hasNewTemplate.value,
  () => {
    emit('close');
    progress.value = ProgressConstants.maxProgress;
    router.push({ name: PathName.ContentLibrary });
  }
);
</script>
<style lang="scss" scoped>
.intersection {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem;
  text-align: center;
  max-width: 22.5rem;
  margin-left: auto;
  margin-right: auto;

  .progress-bar {
    margin-bottom: var(--spacing-100);
  }

  .title {
    margin-bottom: var(--spacing-25);
  }

  .try-again {
    margin-top: var(--spacing-150);
  }

  .template-gif {
    width: 100%;
    margin-bottom: var(--spacing-150);
  }
}
</style>
